import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Button from '../../../Button';
import { getAsset } from '../../../../../util/assets';
import getConfig from '../../../../../util/config';
import useSlideUploadSuccess from './hooks/useSlideUploadSuccess';
import { BASENAME } from '../../../../../constants/basenames';

const propTypes = {
  albumId: PropTypes.string.isRequired,
  onUploadMore: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};

const SlideUploadSuccess = ({ albumId, onUploadMore, onRequestClose }) => {
  const { album, albumFolder } = useSlideUploadSuccess({ albumId });

  const isWebGallery = albumFolder?.is_web_gallery ?? album?.is_web_gallery;
  const isOnboardable = albumFolder?.joins_enabled || album?.joins_enabled;

  const startOnboarding = () => {
    window.open(
      `${getConfig().app.baseUrl}/discover/album-folder/${albumFolder?.id}`,
      '_blank',
    );

    onRequestClose();
  };

  // If the user got here they're authenticated so land them on the PM url
  const skipOnboarding = () => {
    window.open(
      `${getConfig().app.baseUrl}/${BASENAME.SHUTTERBUG}/hierarchy-items/${
        albumFolder?.id
      }`,
      '_blank',
    );

    onRequestClose();
  };

  const uploadPhotos = () => {
    window.open(
      `${getConfig().app.baseUrl}/contributors/u/${albumFolder?.id}`,
      '_blank',
    );

    onRequestClose();
  };

  return (
    <Fragment>
      <div className="d-flex flex-column flex-md-row w-100">
        <Button className="w-100 mr-md-1" btnOutline onClick={onRequestClose}>
          View slideshow
        </Button>
        <Button className="w-100 ml-md-1 mt-2 mt-md-0" onClick={onUploadMore}>
          Upload more to slideshow
        </Button>
      </div>

      <p className="my-2 text-light text-bold text-center">OR</p>

      <div className="album-slideshow-onboarding-actions">
        {isWebGallery && (
          <div className="album-slideshow-onboarding-action">
            <img src={getAsset('/waldo-view-photos.png')} alt="View Photos" />
            <div className="album-slideshow-onboarding-action-content">
              <p>
                View all the photos <br className="d-none d-md-block" /> in this
                gallery!
              </p>
              <Button btnBlock onClick={skipOnboarding}>
                View Photos
              </Button>
            </div>
          </div>
        )}
        {isOnboardable && (
          <div className="album-slideshow-onboarding-action">
            <img src={getAsset('/waldo-way.png')} alt="Find my photos" />
            <div className="album-slideshow-onboarding-action-content">
              <p>
                Ask Waldo to find <br className="d-none d-md-block" /> the
                photos you&rsquo;re in!
              </p>
              <Button btnBlock onClick={startOnboarding}>
                Find My Photos
              </Button>
            </div>
          </div>
        )}
        <div className="album-slideshow-onboarding-action">
          <img
            src={getAsset('/upload-photos-illustration.svg')}
            alt="Upload Photos"
          />
          <div className="album-slideshow-onboarding-action-content">
            <p>
              Snapped photos? <br className="d-none d-md-block" />
              Add yours here!
            </p>
            <Button btnBlock onClick={uploadPhotos}>
              Upload Photos
            </Button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

SlideUploadSuccess.propTypes = propTypes;

export default SlideUploadSuccess;
